import styled from 'styled-components';

import { EditorStyled } from '@xing-com/crate-articles-article-editor';
import { mediaSmallOrTiny } from '@xing-com/layout-tokens';
import { space4XL, space5XL } from '@xing-com/tokens';

export const EditorContent = styled.div`
  ${EditorStyled.EditorStyle}

  margin-bottom: ${space5XL};

  @media ${mediaSmallOrTiny} {
    margin-bottom: ${space4XL};
  }
`;
